import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface Draft {
  draftId: string;
  studioId: string;
  sessionId: string;
  sessionName: string;
  fromDate: string;
  toDate: string;
  createdAt: string;
}

export interface SessionFilter {
  sessionId: string;
  sessionName: string;
}

export interface DraftsResponse {
  success: boolean;
  data: Array<Draft>;
  filters: {
    sessions: Array<SessionFilter>;
  };
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export interface GetDraftsParams {
  page?: number;
  limit?: number;
  sessionId?: string;
  fromDate?: string;
  toDate?: string;
}

const getDraftsAPI = async (
  params: GetDraftsParams = {},
): Promise<DraftsResponse> => {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append('page', params.page.toString());
  if (params.limit) queryParams.append('limit', params.limit.toString());
  if (params.sessionId) queryParams.append('sessionId', params.sessionId);
  if (params.fromDate) queryParams.append('fromDate', params.fromDate);
  if (params.toDate) queryParams.append('toDate', params.toDate);

  const { data } = await baseAPI.get<DraftsResponse>(
    `/hourly-tuition-billing/drafts?${queryParams}`,
  );
  return data;
};

export const useGetDrafts = (params: GetDraftsParams = {}) => {
  return useQuery({
    queryKey: [KEYS.HOURLY_TUITION_BILLING, KEYS.DRAFTS, params],
    queryFn: () => getDraftsAPI(params),
    enabled: true,
  });
};
